import compact from "lodash/compact";
import { NotificationGroupType } from "PFCore/types";
import { Option } from "PFTypes/options";
import { useTranslation } from "react-i18next";

import { useNotificationsPanelContext } from "../contexts/notifications_panel_context";

const ALL_GROUPING_OPTIONS = [
  NotificationGroupType.None,
  NotificationGroupType.EngagementId,
  NotificationGroupType.RoleId,
  NotificationGroupType.Category
];

const filtersToAvailableGroupingMap = {
  noFilter: [NotificationGroupType.None],
  engagement: [NotificationGroupType.None, NotificationGroupType.RoleId, NotificationGroupType.Category],
  role: [NotificationGroupType.None, NotificationGroupType.Category],
  categories: [NotificationGroupType.None, NotificationGroupType.EngagementId, NotificationGroupType.RoleId]
};

export const useAvailableGroupingOptions = () => {
  const { t } = useTranslation("translation", { keyPrefix: "notifications.filters.groupBy" });
  const { engagement, role, categories } = useNotificationsPanelContext();

  const selectedGroupingOptions = compact([
    engagement ? filtersToAvailableGroupingMap.engagement : undefined,
    role ? filtersToAvailableGroupingMap.role : undefined,
    categories.length ? filtersToAvailableGroupingMap.categories : undefined
  ]);

  const availableGrouping = !selectedGroupingOptions.length
    ? filtersToAvailableGroupingMap.noFilter
    : ALL_GROUPING_OPTIONS.filter((option) =>
        selectedGroupingOptions.every((options) => options.includes(option))
      );

  return availableGrouping.map(
    (option) =>
      ({
        id: option,
        original: option,
        value: option,
        displayElement: t(option)
      }) as Option<NotificationGroupType>
  );
};
